// External imports
import React, { useEffect, useReducer } from "react";
import { Navigate } from "react-router-dom";

// Internal imports
import { getJwt } from "../../core/LocalStorage/AuthSession/core";

/*
Gate a route on a live session, sending a visitor without one to "/".

The session is read on every render, so each navigation re-checks it. A storage
event is the only signal reaching a tab that is already sitting on a page when
another tab logs out.

@children: the page to show while the session is live.
 */
export const RequireAuth: React.FC<{ children: React.ReactElement }> = ({
    children,
}) => {
    const [, recheckSession] = useReducer((count: number) => count + 1, 0);

    useEffect(() => {
        // storage fires only in the other tabs, and for any key written, so the
        // session is read back rather than inferred from the event.
        window.addEventListener("storage", recheckSession);
        return () => window.removeEventListener("storage", recheckSession);
    }, []);

    // getJwt() returns null once the refresh token has expired, so an expired
    // session leaves by the same path as a missing one.
    if (!getJwt()) {
        // replace, so Back does not return to the guarded entry.
        return <Navigate to="/" replace />;
    }

    return children;
};
